import { render, staticRenderFns } from "./aidaClassList.vue?vue&type=template&id=5266bc01&"
import script from "./aidaClassList.vue?vue&type=script&lang=js&"
export * from "./aidaClassList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports